//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
	name: 'TreeNode',
	props: ['node', 'selected_node'],
	components: {
		TreeNode: () => frappe.ui.components.TreeNode
	}
}
